import { createContext, useContext, useEffect, useState } from "react";
import { ServerContext } from "./ServerContext";

export const ChangeLogContext = createContext(null);

const DASH = 1;            // ou dinâmico
const CHECK_INTERVAL = 60000; // 1 minuto
const STORAGE_KEY = `changelog_last_seen_id_dash_${DASH}`;
const NOTICE_DISMISS_KEY = `changelog_notice_dismissed_dash_${DASH}`;


// ─── Configuração do aviso fixo ───────────────────────────────────────────────
const FIXED_NOTICE = {
  id: "notice_2026_06",                          // mude ao criar um novo aviso
  validUntil: new Date("2026-08-16T23:59:59"),   // 1 mês de validade
  titleKey: "dashboard.notice_title",
  messageKey: "dashboard.notice_message",
  learnMoreUrl: "/flu/help#19",     // null para omitir o link
};
// ─────────────────────────────────────────────────────────────────────────────

function isNoticeActive(notice) {
  return new Date() <= notice.validUntil;
}

export function ChangeLogProvider({ children }) {
  const { servidor } = useContext(ServerContext);

  const [showNotice, setShowNotice] = useState(false);
  const [hasNewChangeLog, setHasNewChangeLog] = useState(false);
  const [latestChangeLog, setLatestChangeLog] = useState(null);
  const [lastSeenId, setLastSeenId] = useState(null);

  // Aviso fixo: exibe se ainda é válido e o usuário não dispensou este ID
  useEffect(() => {
    if (!isNoticeActive(FIXED_NOTICE)) return;
    const dismissed = localStorage.getItem(NOTICE_DISMISS_KEY);
    if (dismissed !== FIXED_NOTICE.id) {
      setShowNotice(true);
    }
  }, []);

  // Carrega o último ID visto inicialmente
  useEffect(() => {
    if (!servidor) return;

    const storedId = localStorage.getItem(STORAGE_KEY);
    if (storedId) {
      setLastSeenId(Number(storedId));
      return; // já temos referência, não precisa chamar a API agora
    }

    // 2) Se não tiver cache, busca o último da API e considera como "visto"
    fetch(`${servidor}/api/changelogs/${DASH}`)
      .then((r) => r.json())
      .then((data) => {
        if (data?.length) {
          setLastSeenId(data[0].id_change_log);
          localStorage.setItem(STORAGE_KEY, String(data[0].id_change_log));
        }
      })
      .catch(() => {});
  }, [servidor]);

  // Verificação periódica
  useEffect(() => {
    if (!servidor || !lastSeenId) return;

    /*const check = async () => {
      try {
        const resp = await fetch(
          `${servidor}/api/changelogs/latest/${DASH}`
        );
        if (!resp.ok) return;

        const data = await resp.json();
        if (!data) return;

        if (data.id_change_log !== lastSeenId) {
          setHasNewChangeLog(true);
          setLatestChangeLog(data);
        }
      } catch {
        
      }
    };

    const interval = setInterval(check, CHECK_INTERVAL);
    return () => clearInterval(interval);*/

    //omitir por enquanto a verificação de novo changelog, para focar no aviso fixo

    return; // remover quando reativar a verificação de changelog
  }, [servidor, lastSeenId]);

  function dismissNotice() {
    localStorage.setItem(NOTICE_DISMISS_KEY, FIXED_NOTICE.id);
    setShowNotice(false);
  }

  // Marcar como "visto"
  function markAsSeen() {
    if (latestChangeLog) {
      setLastSeenId(latestChangeLog.id_change_log);
      localStorage.setItem(STORAGE_KEY, String(latestChangeLog.id_change_log));
    }
    setHasNewChangeLog(false);
  }

  return (
    <ChangeLogContext.Provider
      value={{
        showNotice,
        fixedNotice: FIXED_NOTICE,
        dismissNotice,
        hasNewChangeLog,
        latestChangeLog,
        markAsSeen,
      }}
    >
      {children}
    </ChangeLogContext.Provider>
  );
}
